import { Navigate, useLocation } from 'react-router-dom';

/** Client-side 301-style redirect for legacy flat URLs → hub-and-spoke paths. */
export default function LegacyRedirect({ to }) {
  const location = useLocation();
  return <Navigate to={`${to}${location.search}${location.hash}`} replace />;
}
